import { Controller } from "@hotwired/stimulus";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

// Connects to data-controller="ministy-scales--member-statistics"
export default class extends Controller {
  static targets = ["roleChart", "weekdayChart", "monthlyChart"];
  static values = {
    rolesData: Object,
    weekdayData: Object,
    monthlyData: Object,
  };

  connect() {
    this.colors = [
      "rgba(54, 162, 235, 0.8)",
      "rgba(255, 99, 132, 0.8)",
      "rgba(75, 192, 192, 0.8)",
      "rgba(255, 206, 86, 0.8)",
      "rgba(153, 102, 255, 0.8)",
      "rgba(255, 159, 64, 0.8)",
      "rgba(199, 199, 199, 0.8)",
      "rgba(83, 102, 255, 0.8)",
      "rgba(40, 159, 64, 0.8)",
      "rgba(210, 199, 199, 0.8)",
    ];

    this.initializeCharts();
    this.initializeModals();
  }

  initializeCharts() {
    this.createRoleChart();
    this.createWeekdayChart();
    this.createMonthlyChart();
  }

  createRoleChart() {
    const ctx = this.roleChartTarget.getContext("2d");

    this.roleChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: Object.keys(this.rolesDataValue),
        datasets: [
          {
            label: "Escalas por Função",
            data: Object.values(this.rolesDataValue),
            backgroundColor: this.colors,
            borderColor: this.colors.map((color) => color.replace("0.8", "1")),
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  }

  createWeekdayChart() {
    const ctx = this.weekdayChartTarget.getContext("2d");

    this.weekdayChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: Object.keys(this.weekdayDataValue),
        datasets: [
          {
            label: "Escalas por Dia da Semana",
            data: Object.values(this.weekdayDataValue),
            backgroundColor: this.colors,
            borderColor: this.colors.map((color) => color.replace("0.8", "1")),
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  }

  createMonthlyChart() {
    const ctx = this.monthlyChartTarget.getContext("2d");

    this.monthlyChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: Object.keys(this.monthlyDataValue),
        datasets: [
          {
            label: "Escalas por Mês",
            data: Object.values(this.monthlyDataValue),
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 2,
            tension: 0.3,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  }

  initializeModals() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.boundHandleKeydown);
  }

  openModal(event) {
    const modalId = event.currentTarget.getAttribute("data-modal-target");
    const modal = document.getElementById(modalId);

    if (modal) {
      modal.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }
  }

  closeModal(event) {
    // Encontrar o modal pai - pode estar na estrutura HTML ou buscar por ID
    let modal = event.currentTarget.closest(".modal");

    // Se não encontrou pelo closest, procurar por todos os modais visíveis
    if (!modal) {
      modal = document.querySelector(".modal:not(.hidden)");
    }

    if (modal) {
      modal.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }

  closeModalOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      event.currentTarget.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      const openModal = document.querySelector(".modal:not(.hidden)");
      if (openModal) {
        openModal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      }
    }
  }

  // Cleanup event listeners when controller disconnects
  disconnect() {
    super.disconnect?.();

    if (this.boundHandleKeydown) {
      document.removeEventListener("keydown", this.boundHandleKeydown);
    }

    // Cleanup charts
    if (this.roleChart) this.roleChart.destroy();
    if (this.weekdayChart) this.weekdayChart.destroy();
    if (this.monthlyChart) this.monthlyChart.destroy();
  }
}
